export const EventBusValues = {
  OpenDialog: 'OpenDialog',
  CloseAllDialogs: 'CloseAllDialogs',
  UpdateLoggedPerson: 'UpdateLoggedPerson',
  LinkSocialIdentity: 'LinkSocialIdentity',
  AccountLinkSuccess: 'AccountLinkSuccess',
};

const EventBus = {
  //Purpose: Registers a listener for a specific event.
  on(event: string, callback: (detail: any) => void) {
    document.addEventListener(event, (e: Event) => callback((e as CustomEvent).detail));
  },
  //Purpose: Triggers (fires) an event, optionally passing data to listeners.
  dispatch(event: string, data?: any) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event: string, callback: EventListenerOrEventListenerObject) {
    document.removeEventListener(event, callback);
  },
};

export default EventBus;
